import {
  Button,
  InputLabel,
  MenuItem,
  TextField,
  Typography,
} from "@material-ui/core";
import { useState, useEffect } from "react";
import useStyles from "./tarifasSectionStyles";

const TarifasSection = ({
  productos,
  cargando,
  error,
  onReintentar,
  onEmitir,
  emitiendo,
  onCancelar,
  cancelando,
}) => {
  const classes = useStyles();
  const [selectedSubGroups, setSelectedSubGroups] = useState({});

  useEffect(() => {
    if (!Array.isArray(productos) || productos.length === 0) return;
    setSelectedSubGroups((prev) => {
      const next = { ...prev };
      productos.forEach((p) => {
        if (
          next[p.productId] === undefined &&
          Array.isArray(p.subGroups) &&
          p.subGroups.length === 1
        ) {
          next[p.productId] = p.subGroups[0].subGroup;
        }
      });
      return next;
    });
  }, [productos]);

  const handleSubGroupChange = (productId, value) =>
    setSelectedSubGroups((prev) => ({ ...prev, [productId]: value }));

  const allSelected = () =>
    Array.isArray(productos) &&
    productos.length > 0 &&
    productos.every((p) => selectedSubGroups[p.productId]);

  const handleEmitir = () => {
    const subgroupInfo = productos.map((p) => ({
      productId: p.productId,
      subGroup: selectedSubGroups[p.productId],
    }));
    onEmitir({ subgroupInfo });
  };

  let contenido;
  if (cargando) {
    contenido = <p className={classes.mensaje}>Cargando productos...</p>;
  } else if (error) {
    contenido = (
      <div className={classes.errorBox}>
        <Typography className={classes.errorText}>
          No fue posible obtener los subgrupos.
        </Typography>
        <Button
          variant="contained"
          onClick={onReintentar}
          className={classes.button}
        >
          Reintentar
        </Button>
      </div>
    );
  } else {
    contenido = (
      <div className={classes.productos}>
        {Array.isArray(productos) &&
          productos.map((p) => (
            <div key={p.productId} className={classes.producto}>
              <Typography className={classes.productoTitle}>
                Producto {p.productId}
              </Typography>
              <InputLabel className={classes.label}>Subgrupo *</InputLabel>
              <TextField
                select
                fullWidth
                size="small"
                variant="outlined"
                value={selectedSubGroups[p.productId] || ""}
                onChange={(e) =>
                  handleSubGroupChange(p.productId, e.target.value)
                }
                disabled={emitiendo}
              >
                <MenuItem value="">Seleccionar...</MenuItem>
                {Array.isArray(p.subGroups) &&
                  p.subGroups.map((s) => (
                    <MenuItem key={s.subGroup} value={s.subGroup}>
                      {s.subGroup}
                    </MenuItem>
                  ))}
              </TextField>
            </div>
          ))}
      </div>
    );
  }

  return (
    <div className={classes.root}>
      <Typography variant="h6" className={classes.title}>
        Subgrupos por producto
      </Typography>
      {contenido}
      <div className={classes.acciones}>
        <Button
          variant="text"
          className={classes.cancelar}
          disabled={emitiendo || cancelando}
          onClick={onCancelar}
        >
          Cancelar
        </Button>
        <Button
          variant="contained"
          className={classes.button}
          disabled={cargando || error || emitiendo || cancelando || !allSelected()}
          onClick={handleEmitir}
        >
          {emitiendo ? "Emitiendo..." : "Emitir"}
        </Button>
      </div>
    </div>
  );
};

export default TarifasSection;
